import { gql } from "@apollo/client";

export const GET_FOLDER_HEADER_QUERY = gql`
  query folderHeader($documentId: Int!, $siteId: Int!) {
    folderHeader(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      folderNumber
      folderDate
      client {
        clientId
        clientName
        clientTypeName
        clientTypeCode
        activityFieldCode
        uniqueId
        familyMembersNumber
        relationType
        relationTypeCode
        partnerType {
          isPF
          isPJ
          isPFA
        }
        defaultEmail
      }
      stateId
      documentTypeId
      stateName
      stateCode
      partnerGroupId
      partnerGroup
      generalInfo {
        responsibleId
        responsibleName
        accountManagerId
        accountManagerName
        folderTypeId
        riskAnalysisTypeId
        folderType
        rorac
        internalInterestRate
        showRORAC
        showIIR
        renewedFacilityId
        renewedFacilitySiteId
        renewedFacilityNumber
        canCalculateApproval
        showScoring
      }
      activeStep
      hasProperties
      facilityId
      facilitySiteId
      offerId
      offerSiteId
    }
  }
`;

export const GET_FOLDER_HEADER_ALPHA_QUERY = gql`
  query folderHeaderAlpha($documentId: Int!, $siteId: Int!) {
    folderHeaderAlpha(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      folderNumber
      folderDate
      client {
        clientId
        partnerId
        clientName
        clientTypeName
        clientTypeCode
        activityFieldCode
        uniqueId
        familyMembersNumber
        relationType
        relationTypeCode
        defaultEmail
        partnerType {
          isPF
          isPJ
          isPFA
        }
      }
      stateId
      documentTypeId
      stateName
      stateCode
      partnerGroupId
      partnerGroup
      generalInfo {
        responsibleId
        responsibleName
        accountManagerId
        accountManagerName
        folderTypeId
        riskAnalysisTypeId
        folderType
        rorac
        internalInterestRate
        showRORAC
        showIIR
        renewedFacilityId
        renewedFacilitySiteId
        renewedFacilityNumber
        canCalculateApproval
        showScoring
      }
      activeStep
      hasProperties
      facilityId
      facilitySiteId
      offerId
      offerSiteId
    }
  }
`;

export const GET_ACCOUNT_MANAGERS_QUERY = gql`
  query accountManagers($search: String) {
    accountManagers(search: $search) {
      accountManagerId
      name
      uniqueId
    }
  }
`;

export const GET_RISK_RESPONSIBLES_QUERY = gql`
  query riskResponsibles {
    riskResponsibles {
      responsibleId
      name
      email
      phone
      inactive
    }
  }
`;

export const GET_RISK_ANALYSIS_TYPES_QUERY = gql`
  query riskAnalysisTypes($documentTypeId: Int!) {
    riskAnalysisTypes(documentTypeId: $documentTypeId) {
      dictionaryItemId
      dictionaryItemName
      implicit
    }
  }
`;

export const GET_OFFER_TYPES_QUERY = gql`
  query offerTypes($documentTypeId: Int!) {
    offerTypes(documentTypeId: $documentTypeId) {
      OfferTypeId
      offerTypeName
      offerTypeCode
      isSystem
      implicit
    }
  }
`;

export const GET_PARTNER_QUERY = gql`
  query partner($uniqueId: String) {
    partner(uniqueId: $uniqueId) {
      partnerId
      uniqueID
      partnerName
      phoneNumber
      e_Mail
      uniqueIdClean
      phoneCountryCode
    }
  }
`;

export const GET_PARTNERS_LIST_QUERY = gql`
  query partnersList($search: String) {
    partnersList(search: $search) {
      id
      uniqueId
      partnerName
    }
  }
`;
